import React from 'react';
import { Box, TextV2 } from '@withjoy/joykit';
import { SectionTitleComponent, SurveyComponent } from '../Survey.types';

interface SectionTitleRendererProps {
  component: SurveyComponent;
}

export const SectionTitleRenderer: React.FC<SectionTitleRendererProps> = ({ component }) => {
  const sectionTitleComponent = component as SectionTitleComponent;

  return (
    <Box marginBottom={4}>
      <TextV2
        typographyVariant="hed3"
        color="mono14"
        marginBottom={sectionTitleComponent.subtitle ? 2 : 0}
      >
        {sectionTitleComponent.title}
      </TextV2>
      {sectionTitleComponent.subtitle && (
        <TextV2
          typographyVariant="body1"
          color="mono12"
        >
          {sectionTitleComponent.subtitle}
        </TextV2>
      )}
    </Box>
  );
};
